<template>
  <b-skeleton
    v-if="isBreadcrumbLoading"
    type="input"
    height="3rem"
    animation="fade"
  />
  <div
    v-else-if="!isShowingNotFoundPage && breadcrumbItemList.length > 0"
  >
    <div class="menu-breadcrumb">
      <div class="container">
        <div class="row">
          <div class="col-12" itemscope itemtype="https://schema.org/BreadcrumbList">
            <span
              v-for="item in breadcrumbItemList"
              :key="item.url"
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
            >
              <router-link
                v-if="item.showSeparator"
                :to="item.url"
                :title="item.title"
                itemprop="item"
                class="breadcrumb-link breadcrumb-link-not-last"
              >
                <span class="d-none" itemprop="id" v-text="item.url" />
                <span itemprop="name" v-text="item.title" />
              </router-link>
              <router-link
                v-else
                :to="$route.fullPath"
                :title="item.title"
                itemprop="item"
                class="breadcrumb-link breadcrumb-link-last"
              >
                <span class="d-none" itemprop="id" v-text="item.url" />
                <span itemprop="name" v-text="item.title" />
              </router-link>
              <meta
                itemprop="position"
                :content="item.position"
              >
              <span
                v-if="item.showSeparator"
                class="link-separator"
              >
                <div class="icon-arrow arrow-right" />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { BSkeleton } from 'bootstrap-vue'

export default {
  name: 'Breadcrumb',
  components: {
    'b-skeleton': BSkeleton,
  },
  props: {
    /**
     * A function breadcrumbize()-ban lévő $module - elnevezés
     */
    pageName: {
      type: String,
      default: '',
    },
    /**
     * A function breadcrumbize()-ban lévő $node
     * Most nem használjuk de később kelleni fog
     * TODO: Később még kelleni fog!
     */
    node: {
      type: String,
      default: '',
    },
    /**
     * épp 404 vue page-t mutatjuk-e
     */
    isShowingNotFoundPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /**
       * breadcrumb item lista snippet
       */
      breadcrumbItemList: [],
      /**
       * töltődik-e a breadcrumb
       */
      isBreadcrumbLoading: false,
    }
  },
  created() {
    /**
     * oldalváltáskor breadcrumb ujrarenderelés feliratkozás
     */
    this.$root.$on('breadcrumbChange', this.updateBreadcrumb)
  },
  destroyed() {
    /**
     * oldalváltáskor breadcrumb ujrarenderelés leiratkozás
     */
    this.$root.$off('breadcrumbChange', this.updateBreadcrumb)
  },
  methods: {
    /**
     * breadcrumb refresh
     *
     * @param params {{
     *  pageName: String,
     *  node: String,
     *  needInstance: Boolean,
     *  instanceType: String,
     * }}
     */
    updateBreadcrumb(params) {
      this.breadcrumbItemList = []
      if (params.pageName === '') {
        return
      }
      this.isBreadcrumbLoading = true
      axios.get('/Portal/api/getBreadCrumbContent', {
        params: {
          pageName: params.pageName,
          node: params.node,
          needInstance: params.needInstance,
          instanceType: params.instanceType,
        },
      })
        .then(({data}) => {
          this.breadcrumbItemList = data
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.isBreadcrumbLoading = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
.menu-breadcrumb {
  padding: var(--breadcrumb-padding);
  line-height: var(--breadcrumb-line-height);
  width: 100%;
  color: var(--breadcrumb-breadcrumb-link-not-last-color);
  background-color: var(--breadcrumb-background-color);
  font-size: 1.375rem;

  @media screen and (max-width: 991px) {
    font-size: .75rem;
  }

  .link-separator{
    font-size: 12px;
    padding-left: 3px;
    padding-right: 10px;

    .icon-arrow {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-color: var(--breadcrumb-breadcrumb-link-not-last-color);
    }
  }
}

.breadcrumb-link-not-last {
  color: var(--breadcrumb-breadcrumb-link-not-last-color) !important;
  font-size: 13px;
}

.breadcrumb-link-last {
  /*
   * important kell hogy felül üssük a normál a szinét, mert már mindenhol is important van
   * az új designban már nem lesz ilyen
   */
  color: var(--breadcrumb-breadcrumb-link-last-color) !important;
  cursor: default !important;
  font-size: 13px;
}
</style>
